module.exports = __webpack_public_path__ + "img/tk.7aaccddb.svg";